document.addEventListener('DOMContentLoaded', () => {
    const navbar = document.querySelector('.wp-block-wm-cardioline-navigation');

    navbar.querySelector('.wp-block-wm-cardioline-navigation__open').addEventListener('click', () => {
        navbar.querySelector('.wp-block-wm-cardioline-navigation__menu').classList.add('-open');
    });
    navbar.querySelector('.wp-block-wm-cardioline-navigation__close').addEventListener('click', () => {
        navbar.querySelector('.wp-block-wm-cardioline-navigation__menu').classList.remove('-open');
    });
});